import { useEffect, useState } from "react";
import posthog from "./posthog";

// Strict-true gate: state stays false until PostHog reports basic_search === true.
// Deactivated flags return undefined from isFeatureEnabled (not false), so an
// `!== false` test would leave deactivated flags reading as "on".
export function useBasicSearchFlag(): boolean {
  const [enabled, setEnabled] = useState<boolean>(
    () => posthog.isFeatureEnabled("basic_search") === true,
  );
  useEffect(() => {
    const unsub = posthog.onFeatureFlags(() => {
      setEnabled(posthog.isFeatureEnabled("basic_search") === true);
    });
    return () => {
      if (typeof unsub === "function") unsub();
    };
  }, []);
  return enabled;
}
